export default __webpack_public_path__ + "static/logo-ffaeae9478c62e7a4d822094a207ae60.svg";